module.exports = __webpack_public_path__ + "img/saks5.55332114.jpg";